import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import styles from "./MainLayout.module.css";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { useTranslation } from "react-i18next";

import { IoIosArrowUp } from "react-icons/io";
import logo from "../../assets/images/The-Record-Hub-Logo.png";
import CookieConsent from "../../components/cookieConsent/CookieConsent";

const lngs = {
  en: { displayName: "EN" },
  el: { displayName: "EL" },
};

const MainLayout = () => {
  const { i18n } = useTranslation();
  const [showScrollToToBtn, setShowScrollToToBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setShowScrollToToBtn(window.scrollY > 250);
    });
  }, []);

  return (
    <div className={styles.mainContainer}>
      <Navbar logo={logo} i18n={i18n} />
      <div className={styles.content}>
        <Outlet />
      </div>

      <Footer />

      <div className={styles.changeLangBtn}>
        {lngs[i18n.language].displayName}
        <div className={styles.langChoicesContainer}>
          {lngs &&
            Object.keys(lngs)
              .filter(
                (lng) =>
                  lngs[lng].displayName !== lngs[i18n.language].displayName
              )
              .map((lng, i) => (
                <Link
                  key={`change_lang_link_${i}`}
                  to="#"
                  className={styles.langChoice}
                  onClick={(e) => {
                    e.preventDefault();
                    i18n.changeLanguage(lng);
                  }}
                >
                  {lngs[lng].flag}
                  {lngs[lng].displayName}
                </Link>
              ))}
        </div>
      </div>

      <button
        onClick={() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }}
        style={{
          display: !showScrollToToBtn && "none",
        }}
        className={styles.scrollToTopBtn}
      >
        <IoIosArrowUp size="16" />
      </button>
      <CookieConsent />
    </div>
  );
};

export default MainLayout;
